export default {"src":"/_next/static/media/gymnastiek.ad6cf16e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};